import React from "react";

import { Badge } from "../Badge";
import { ValuationBadgeProps } from "./types";

// Shared across the portfolio table/card and both ledger surfaces to stop a four-copy drift.
// role="note" not Badge's default "status": status is an ARIA live region, and a ten-row table would queue ten announcements per refetch.
export const ValuationBadge: React.FC<ValuationBadgeProps> = ({
  badge,
  hasVisibleNote = false,
  className,
}) => {
  // Omit the aria label when the note is already visible, or a screen reader repeats it.
  const message = hasVisibleNote ? undefined : badge.message;

  return (
    <Badge
      variant={badge.variant}
      style="soft"
      size="small"
      role="note"
      className={className}
      title={message}
      aria-label={message}
    >
      {badge.label}
    </Badge>
  );
};
